import { Button, styled } from '@mui/material'

const StyledButton = styled(Button)((props) => ({
    textTransform: 'capitalize',
    fontSize: '14px',
    height: '31px !important',
    color: '#ff5e65 !important',
    backgroundColor: '#ffffff !important',
    border: '1px solid #ff5e65',
    boxShadow: 'none',
    margin: 0,
    minWidth: '65px !important',
    padding: '8px 12px',
    lineHeight: 0,

    '&:hover': {
        color: '#ffffff !important',
        backgroundColor: '#ff5e65 !important',
        borderColor: 'transparent !important',
    },
    ...props.styles,
}))

const DeleteButton = ({ color, styles, children, ...rest }) => {
    return (
        <StyledButton variant="outlined" size="small" styles={styles} {...rest}>
            {children}
        </StyledButton>
    )
}

export default DeleteButton
